module.exports = __webpack_public_path__ + "fonts/AntykwaTorunskaCond-Regular.be142a92.ttf";